const mapping: Record<
  string,
  (lambdaParameter: string, value: any, otherValues: any) => string | null
> = {
  jobTargetMethod: (lambdaParameter, value) =>
    `${lambdaParameter}.JobTargetMethod.Contains("${value}")`,
  jobStatus: (lambdaParameter, value) =>
    `${lambdaParameter}.JobStatus.Equals("${value}")`,
  recurringJobParentId: (lambdaParameter, value) =>
    `${lambdaParameter}.RecurringJobParentId.Equals("${value}")`,
}

export const filterMapper = (key: string) =>
  mapping[key] as (
    lambdaParameter: string,
    value: any,
    otherValues: any,
  ) => string

export default filterMapper
